import { BaseForm } from "app/components/common/forms/BaseForm"

export const useHook = () => {
    const [form] = BaseForm.useForm()
    return {
        form
    }
}